<template>
  <footer class="footer">
    <div class="container-fluid">
      <ul class="nav">
        <li class="nav-item">
          <a
            href="https://www.peamoni.fr"
            target="_blank"
            rel="noopener"
            class="nav-link"
          >
            Peamoni
          </a>
        </li>
        <li class="nav-item ml-1">
          <router-link class="nav-item" tag="li" to="/about">
            <a class="nav-link">À propos</a>
          </router-link>
        </li>
        <li class="nav-item ml-1">
          <router-link class="nav-item" tag="li" to="/terms">
            <a class="nav-link">INFOS LÉGALES</a>
          </router-link>
        </li>
      </ul>
      <div class="copyright">
        <span class="mr-2">Version {{version}}</span>
        &copy; {{ year }}, made with
        <i class="tim-icons icon-heart-2"></i> in Angers.
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear(),
      version: process.env.PACKAGE_VERSION
    };
  }
};
</script>
<style></style>
